import React from 'react';
import Container from '@common/components/container';
import DataTable from '@common/components/datatable';
import Overview from '@common/components/overview';
import Placeholder from '@common/components/placeholder';
import { useAppSelector } from '@common/hooks';
import { useRequest } from '@common/services/api';
import { selected } from '@modules/organisation/selectors/organisation';
import { EvaluationsMeta } from '@modules/performance/types';
import { omit } from 'lodash';
import { useTranslation } from 'react-i18next';
import useColumn from './useColumn';
import { TopNavigationBar } from '@common/components/navigation-bar';
import { DataTableRow } from '@common/components/datatable/types';
import { useHistory, useParams } from 'react-router';

const MyEvaluationsContainer = () => {
  const { t } = useTranslation();
  const org = useAppSelector(selected);
  const params = useParams<{ networkId: string }>();
  const history = useHistory();

  const apiConfig = {
    useCursor: true,
    limit: 20,
    transform: (res: any) => {
      return {
        ...res,
      };
    },
  };

  const basePath = params.networkId
    ? `/networks/${params.networkId}`
    : '/admin';

  const handleRowClick = (row: DataTableRow) => {
    history.push(`${basePath}/performance/evaluations/${row.id}`);
  };

  const {
    data: evaluations,
    meta: metaData,
    loading,
    refetch,
  } = useRequest(
    `/v1/organisations/${org.id}/users/me/performance/evaluations`,
    apiConfig
  );

  const columns = useColumn();

  const meta: EvaluationsMeta = metaData;
  return (
    <Container name="My Evaluations">
      <TopNavigationBar title={t('performance:my_evaluations')} />
      <Container.Content>
        <Overview>
          <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200">
            <DataTable
              columns={columns}
              data={evaluations || []}
              loading={loading}
              onShowMore={refetch}
              onRowClick={handleRowClick}
              pagination={{
                ...omit(apiConfig, 'payload'),
                ...meta?.pagination,
              }}
              emptyView={
                <Placeholder
                  title={t('performance:no_evaluations_placeholder')}
                />
              }
            />
          </div>
        </Overview>
      </Container.Content>
    </Container>
  );
};

export default MyEvaluationsContainer;
